import { FOLDER_VIEWS_PATH } from 'paths'
import { useRouteMatch } from 'react-router-dom'

export const useRouteSchemaId = () => {
  const folderViewsRouteMatch = useRouteMatch(FOLDER_VIEWS_PATH)
  const routeSchemaId = parseInt((folderViewsRouteMatch?.params as any)?.view || 0)

  return routeSchemaId
}
